// src/pages/Reports/RetailerReport.jsx
import React from 'react';
import BusinessReport from './BusinessReport';

const RetailerReport = () => {
  return <BusinessReport userType="retailer" />;
};

export default RetailerReport;